module.exports = __webpack_public_path__ + "static/media/09.Foreign Tour.a9961547.jpg";